'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ALIASES;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Album meta directive. See https://www.chordpro.org/chordpro/Directives-album.html
 * @type {string}
 */
var ALBUM = exports.ALBUM = 'album';

/**
 * Artist meta directive. See https://www.chordpro.org/chordpro/Directives-artist.html
 * @type {string}
 */
var ARTIST = exports.ARTIST = 'artist';

/**
 * Capo meta directive. See https://www.chordpro.org/chordpro/Directives-capo.html
 * @type {string}
 */
var CAPO = exports.CAPO = 'capo';

/**
 * Comment directive. See https://www.chordpro.org/chordpro/Directives-comment.html
 * @type {string}
 */
var COMMENT = exports.COMMENT = 'comment';

/**
 * Composer meta directive. See https://www.chordpro.org/chordpro/Directives-composer.html
 * @type {string}
 */
var COMPOSER = exports.COMPOSER = 'composer';

/**
 * Copyright meta directive. See https://www.chordpro.org/chordpro/Directives-copyright.html
 * @type {string}
 */
var COPYRIGHT = exports.COPYRIGHT = 'copyright';

/**
 * Duration meta directive. See https://www.chordpro.org/chordpro/Directives-duration.html
 * @type {string}
 */
var DURATION = exports.DURATION = 'duration';

/**
 * End of chorus directive. See https://www.chordpro.org/chordpro/Directives-env_chorus.html
 * @type {string}
 */
var END_OF_CHORUS = exports.END_OF_CHORUS = 'end_of_chorus';

/**
 * End of verse directive. See https://www.chordpro.org/chordpro/Directives-env_verse.html
 * @type {string}
 */
var END_OF_VERSE = exports.END_OF_VERSE = 'end_of_verse';

/**
 * Key meta directive. See https://www.chordpro.org/chordpro/Directives-key.html
 * @type {string}
 */
var KEY = exports.KEY = 'key';

/**
 * Lyricist meta directive. See https://www.chordpro.org/chordpro/Directives-lyricist.html
 * @type {string}
 */
var LYRICIST = exports.LYRICIST = 'lyricist';

/**
 * Start of chorus directive. See https://www.chordpro.org/chordpro/Directives-env_chorus.html
 * @type {string}
 */
var START_OF_CHORUS = exports.START_OF_CHORUS = 'start_of_chorus';

/**
 * Start of verse directive. See https://www.chordpro.org/chordpro/Directives-env_verse.html
 * @type {string}
 */
var START_OF_VERSE = exports.START_OF_VERSE = 'start_of_verse';

/**
 * Subtitle meta directive. See https://www.chordpro.org/chordpro/Directives-subtitle.html
 * @type {string}
 */
var SUBTITLE = exports.SUBTITLE = 'subtitle';

/**
 * Tempo meta directive. See https://www.chordpro.org/chordpro/Directives-tempo.html
 * @type {string}
 */
var TEMPO = exports.TEMPO = 'tempo';

/**
 * Time meta directive. See https://www.chordpro.org/chordpro/Directives-time.html
 * @type {string}
 */
var TIME = exports.TIME = 'time';

/**
 * Title meta directive. See https://www.chordpro.org/chordpro/Directives-title.html
 * @type {string}
 */
var TITLE = exports.TITLE = 'title';

/**
 * Year meta directive. See https://www.chordpro.org/chordpro/Directives-year.html
 * @type {string}
 */
var YEAR = exports.YEAR = 'year';

var TITLE_SHORT = 't';
var SUBTITLE_SHORT = 'st';
var COMMENT_SHORT = 'c';
var START_OF_CHORUS_SHORT = 'soc';
var END_OF_CHORUS_SHORT = 'eoc';

var RENDERABLE_TAGS = [COMMENT];

var META_TAGS = exports.META_TAGS = [ALBUM, ARTIST, CAPO, COMPOSER, COPYRIGHT, DURATION, KEY, LYRICIST, TEMPO, TIME, TITLE, SUBTITLE, YEAR];

var ALIASES = (_ALIASES = {}, _defineProperty(_ALIASES, TITLE_SHORT, TITLE), _defineProperty(_ALIASES, SUBTITLE_SHORT, SUBTITLE), _defineProperty(_ALIASES, COMMENT_SHORT, COMMENT), _defineProperty(_ALIASES, START_OF_CHORUS_SHORT, START_OF_CHORUS), _defineProperty(_ALIASES, END_OF_CHORUS_SHORT, END_OF_CHORUS), _ALIASES);

var META_TAG_REGEX = /^meta:\s*([^:\s]+)(\s*(.+))?$/;
var TAG_REGEX = /^([^:\s]+)(:?\s*(.+))?$/;
var CUSTOM_META_TAG_NAME_REGEX = /^x_(.+)$/;

var translateTagNameAlias = function translateTagNameAlias(name) {
  if (!name) {
    return name;
  }

  var sanitizedName = name.trim();

  if (sanitizedName in ALIASES) {
    return ALIASES[sanitizedName];
  }

  return sanitizedName;
};

/**
 * Represents a tag/directive. See https://www.chordpro.org/chordpro/ChordPro-Directives.html
 */

var Tag = function () {
  function Tag(name, value) {
    _classCallCheck(this, Tag);

    this.name = name;
    this.value = value;
  }

  _createClass(Tag, [{
    key: 'hasValue',


    /**
     * Checks whether the tag value is a non-empty string.
     * @returns {boolean}
     */
    value: function hasValue() {
      return this.value !== null && this.value.trim().length > 0;
    }

    /**
     * Checks whether the tag is usually rendered inline. It currently only applies to comment tags.
     * @returns {boolean}
     */

  }, {
    key: 'isRenderable',
    value: function isRenderable() {
      return RENDERABLE_TAGS.indexOf(this.name) !== -1;
    }

    /**
     * Checks whether the tag is either a standard meta tag or a custom meta directive (`{x_some_name}`)
     * @returns {boolean}
     */

  }, {
    key: 'isMetaTag',
    value: function isMetaTag() {
      return CUSTOM_META_TAG_NAME_REGEX.test(this.name) || META_TAGS.indexOf(this.name) !== -1;
    }

    /**
     * Returns a clone of the tag.
     * @returns {Tag} The cloned tag
     */

  }, {
    key: 'clone',
    value: function clone() {
      return new Tag(this.name, this.value);
    }
  }, {
    key: 'toString',
    value: function toString() {
      return 'Tag(name=' + this.name + ', value=' + this.name + ')';
    }
  }, {
    key: 'name',
    set: function set(name) {
      this._name = translateTagNameAlias(name);
      this._originalName = name;
    }

    /**
     * The tag full name. When the original tag used the short name, `name` will return the full name.
     * @member
     * @type {string}
     */
    ,
    get: function get() {
      return this._name.trim();
    }

    /**
     * The original tag name that was used to construct the tag.
     * @member
     * @type {string}
     */

  }, {
    key: 'originalName',
    get: function get() {
      return this._originalName.trim();
    }
  }, {
    key: 'value',
    set: function set(value) {
      this._value = value;
    }

    /**
     * The tag value
     * @member
     * @type {string|null}
     */
    ,
    get: function get() {
      if (this._value) {
        return this._value.trim();
      }

      return this._value || null;
    }
  }], [{
    key: 'parse',
    value: function parse(tag) {
      return this.parseWithRegex(tag, META_TAG_REGEX) || this.parseWithRegex(tag, TAG_REGEX);
    }
  }, {
    key: 'parseWithRegex',
    value: function parseWithRegex(tag, regex) {
      var matches = tag.match(regex);

      if (matches !== null) {
        return new Tag(matches[1], matches[3] || null);
      }

      return null;
    }
  }]);

  return Tag;
}();

exports.default = Tag;


//////////////////
// WEBPACK FOOTER
// ./~/chordsheetjs/lib/chord_sheet/tag.js
// module id = 14
// module chunks = 1